import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import _ from "lodash";

import withAuthority, {
  isUserAuthorized,
} from "../../../../components/Auth/withAuthority";
import Authorities from "../../../../auth/authorities";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import LogsDetailsInfoNode from "./LogsDetailsInfoNode";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import {
  fetchAllLogsInfo,
  fetchAllVGetLogsInfo,
} from "../../../../services/salesApp/logsService";
import { useRouteMatch } from "react-router-dom";

export interface DailyOrderReportProps {}

const LogsDetails: React.FunctionComponent<DailyOrderReportProps> = () => {
  const [error, setError] = useState<string>("");
  const [logsNode, setLogsNode] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const match: any = useRouteMatch();
  const handleGetLogs = async () => {
    try {
      const res = await fetchAllLogsInfo(match.params.locationId, "inventory");

      setLogsNode(res.data.data);
      setIsLoading(false);
    } catch (e) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    document.title = "Inventory - Log Details";
    handleGetLogs();
  }, []);
  return (
    <>
      <Box style={{marginTop: "118px"}}>
        <LogsDetailsInfoNode isLoading={isLoading} logsNode={logsNode} />

        <DefaultAlert
          open={!!error}
          handleClose={() => setError("")}
          message={error}
          severity="error"
        />
      </Box>
    </>
  );
};

export default withAuthority(LogsDetails, Authorities.DASHBOARD_READ);
